"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Board = void 0;
var functions_1 = require("./functions");
var Board = /** @class */ (function () {
    function Board(name) {
        this.name = name;
        this.lists = [];
    }
    Board.prototype.changeName = function (newName) {
        this.name = newName;
    };
    Board.prototype.addList = function (list) {
        this.lists.push(list);
    };
    Board.prototype.removeList = function (listPosition) {
        this.lists.splice(listPosition, 1);
    };
    Board.prototype.moveList = function (oldPosition, newPosition) {
        (0, functions_1.arrayMove)(this.lists, oldPosition, newPosition);
    };
    return Board;
}());
exports.Board = Board;
